export default __webpack_public_path__ + "static/media/ic-test-avg-time.51b5dba2.svg";